import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { callBackend } from "../components/callBackend";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/login.css";

export default function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const toastDict = {
		position: "top-center",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: "dark",
	};

	useEffect(() => {
		if (localStorage.getItem("nssc-admin-token")) {
			navigate("/");
		}
	}, [navigate]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (email && password) {
			callBackend({
				method: "POST",
				endpoint: "/admin/login",
				setLoading,
				data: { email, password },
				onSuccess: (res) => {
					localStorage.setItem("nssc-admin-token", res.token);
					navigate("/");
				},
			});
		} else {
			toast.error("Please fill all the fields", toastDict);
		}
	};

	return (
		<Container className="login-container" fluid>
			<Form className="login-form" onSubmit={handleSubmit}>
				<h3 className="login-title">Admin Login</h3>

				<Form.Group className="mb-3" controlId="formBasicEmail">
					<Form.Label>Email address</Form.Label>
					<Form.Control
						type="email"
						placeholder="Enter email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						className="login-input"
					/>
				</Form.Group>

				<Form.Group className="mb-3" controlId="formBasicPassword">
					<Form.Label>Password</Form.Label>
					<div className="password-wrapper">
						<Form.Control
							type={showPassword ? "text" : "password"}
							placeholder="Password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="login-input"
						/>
						<span
							className="password-toggle"
							onClick={() => setShowPassword(!showPassword)}
						>
							{showPassword ? <FaEyeSlash /> : <FaEye />}
						</span>
					</div>
				</Form.Group>

				<Button variant="primary" type="submit" className="login-btn">
					{loading ? <Spinner animation="border" size="sm" /> : "Login"}
				</Button>
			</Form>
		</Container>
	);
}
